import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/views/Layout/DashboardLayout.vue'
import Home from '@/views/Pages/Home.vue'

import PageLayout from '../views/Pages/PageLayout'
import Login from '../views/Pages/Login'
import Signup from '../views/Pages/Signup'
import Register from '../views/Pages/Register'
import RegisterSuccess from '../views/Pages/RegisterSuccess'
import Terms from '../views/Pages/Terms'
import AdminDashboard from '../views/Dashboard/Admin/AffiliateList/'
import DashboardReport from '../views/Dashboard/Statistics/'
import AffiliateAdminDetails from '../views/Dashboard/Admin/AffiliateDetails/'
import AffiliateAdminStatistics from '../views/Dashboard/Admin/AffiliateStatistics/'
import AffiliateDetails from '../views/Dashboard/Affiliate/'
import NotesList from '../views/Dashboard/Admin/NotesList/NotesList'
import ConfirmAffiliate from '../views/Pages/ConfirmAffiliate'
import SuccessPage from '../views/GeneralViews/SuccessPage'

Vue.use(Router)

import store from '@/store'

const entryRoutes = {
  path: '/affiliates',
  component: PageLayout,
  children: [
    {
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: 'login',
      name: 'Log In',
      component: Login,
      meta: {
        requiresLoggedOut: true
      }
    },
    {
      path: 'register',
      name: 'Register',
      component: Register,
      meta: {
        requiresLoggedIn: true,
        requiredUnEnrolled: true
      }
    },
    {
      path: 'register/success',
      name: 'Register Success',
      component: RegisterSuccess,
      meta: {
        requiresLoggedIn: true,
        requiredUnEnrolled: true,
        mustFrom: 'Register'
      }
    },
    {
      path: 'signup',
      name: 'Sign Up',
      component: Signup,
      meta: {}
    }
  ]
}

const router = new Router({
  mode: 'history',
  routes: [
    entryRoutes,
    {
      path: '/affiliates/',
      redirect: '/affiliates/admin',
      name: 'Dashboard',
      component: DashboardLayout,
      meta: {
        requiresLoggedIn: true
      },
      children: [
        {
          path: 'admin',
          name: 'Admin',
          components: { default: AdminDashboard },
          meta: {
            navbarType: 'light',
            requiresTeam: true
          }
        },
        {
          path: 'affiliate/:id',
          name: 'Affiliate Details',
          components: { default: AffiliateAdminDetails },
          meta: {
            navbarType: 'light',
            requiresTeam: true
          }
        },
        {
          path: 'affiliate/:id/statistics',
          name: 'Affiliate Statistics',
          components: { default: AffiliateAdminStatistics },
          meta: {
            navbarType: 'light',
            requiresTeam: true
          }
        },
        {
          path: 'notes',
          name: 'Notes List',
          components: { default: NotesList },
          meta: {
            navbarType: 'light',
            requiresTeam: true
          }
        },
        {
          path: 'home',
          name: 'Affiliate',
          components: { default: AffiliateDetails },
          meta: {
            navbarType: 'light',
            requiresEnrolled: true
          }
        },
        {
          path: 'statistics',
          name: 'Statistics',
          component: DashboardReport,
          meta: {
            navbarType: 'light'
          }
        },
        {
          path: 'confirm',
          name: 'Confirm Affiliate',
          components: { default: ConfirmAffiliate },
          meta: {
            navbarType: 'light',
            requiresTeam: true
          }
        },
        {
          path: 'confirmed/success',
          name: 'Confirmed Success',
          components: { default: SuccessPage },
          meta: {
            navbarType: 'light',
            requiresTeam: true
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/affiliates'
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeResolve((to, from, next) => {
  const {
    isAuthenticated,
    'affiliates/isEnrolled': isEnrolled,
    'affiliates/isTeam': isTeam
  } = store.getters

  if (
    // Check if Logged In
    !isAuthenticated &&
    to.matched.some((record) => record.meta.requiresLoggedIn)
  ) {
    next({ name: 'Log In', params: { continue: to.fullPath } })
  } else if (
    // Check if Requires Not Logged In OR Not Enrolled
    (isAuthenticated &&
      to.matched.some((record) => record.meta.requiresLoggedOut)) ||
    (isEnrolled && to.matched.some((record) => record.meta.requiredUnEnrolled))
  ) {
    next({ name: 'Affiliate' })
  } else if (
    // Check if Enrolled
    !isEnrolled &&
    to.matched.some((record) => record.meta.requiresEnrolled)
  ) {
    if (isTeam) {
      next({ name: 'Dashboard' })
    } else {
      next({ name: 'Register' })
    }
  } else if (!isTeam && to.matched.some((record) => record.meta.requiresTeam)) {
    //Check if User Is Team
    if (isEnrolled) {
      next({ name: 'Affiliate' })
    } else {
      next({ name: 'Home' })
    }
  } else {
    switch (to.name) {
      case 'Register Success':
        if (from.name === null || !from.name === 'Register') {
          next({ name: 'Dashboard' })
        }
        break
      case 'Confirmed Success':
        if (from.name === null || !from.name === 'Confirm Affiliate') {
          next({ name: 'Dashboard' })
        }
        break
      default:
    }

    next()
  }
})

export default router
